import { Expose, Type } from 'class-transformer';
import { User } from './user.model';
import { Permission } from './permission.model';

export class Role {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  persistent: boolean;

  @Expose()
  @Type(() => User)
  users: User[];

  @Expose()
  @Type(() => Permission)
  permissions: Permission[];
}
